import localforage from 'localforage';
import { CachePersistor, LocalStorageWrapper, LocalForageWrapper } from 'apollo3-cache-persist';
import { ApolloCacheInstance } from './ApolloCacheInstance';

class MockStorage implements Storage {
  [name: string]: any;

  clear(): void {}
  getItem(key: string): string | null { return null; }
  setItem(key: string, value: string): void {}
  removeItem(key: string): void {}
  key(index: number): string | null { return null; }
  get length(): number { return 0; }
}

const mockLocalStorageWrapper = new LocalStorageWrapper(new MockStorage());

export const apolloCachePersistorFactory = (ns = 'default') => {
  const storageInstance = localforage.createInstance({ name: ns });
  return new CachePersistor({
    cache: ApolloCacheInstance,
    storage: typeof window !== 'undefined' ? new LocalForageWrapper(storageInstance) : mockLocalStorageWrapper,
  });
}